import styled, { css } from "styled-components";
import { breakpoints, buildColor } from "@tvg/design-system";
import computeBetTypeSelectorPosition from "./utils/computeBetTypeSelectorPosition";

const computeTopPosition = (isFdr?: boolean, hasFixedBannerTvg5?: boolean) => {
  const bannerHeight = 34;
  if (hasFixedBannerTvg5 && !isFdr) {
    return `calc(var(--hdr-height, 76px) + ${bannerHeight}px)`;
  }
  if (!hasFixedBannerTvg5 && !isFdr) return "var(--hdr-height, 76px)";

  return "0";
};

export const ProgramPageContainer = styled.section<{
  isFdr: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  @media screen and ${breakpoints.tablet.min.sm} {
    ${({ isFdr }) =>
      isFdr &&
      css`
        background-color: ${buildColor("blue", "900")};
      `};
  }
`;

export const BetTypeSelectorContainer = styled.div<{
  isFdr?: boolean;
  withVideo?: boolean;
  withFixedBanner?: boolean;
  betTypeSelectorOffset?: number;
  isLiveTv: boolean;
  isLogged: boolean;
  isAccountCompliant: boolean;
  hasFixedBannerTvg5?: boolean;
}>`
  display: flex;
  flex-direction: column;
  position: sticky;
  top: ${({ isFdr, hasFixedBannerTvg5 }) =>
    computeTopPosition(isFdr, hasFixedBannerTvg5)};
  z-index: 15;

  @media screen and ${breakpoints.tablet.max.sm} {
    top: ${({
      isFdr,
      withVideo,
      withFixedBanner,
      betTypeSelectorOffset,
      isLiveTv,
      isLogged,
      isAccountCompliant
    }) =>
      computeBetTypeSelectorPosition({
        isFdr,
        withVideo,
        withFixedBanner,
        betTypeSelectorOffset,
        isLiveTv,
        isLogged,
        isAccountCompliant
      })};
  }
`;

export const DerbyBannerStyled = styled.div`
  padding-top: 12px;
  background-color: ${({ theme }) => theme.colorTokens.background.base};
`;
